module.exports = __webpack_public_path__ + "static/media/5-9.3c0cd365.mp3";